<template>
  <div class="agent-qrcode">
    <nav-bar 
      titleText="经纪人推广码" 
      @goBack="goBack" 
    >
    </nav-bar>
    
    <div class="content" id="imageWrapper">
      <div class="title">扫码成为解债经纪人</div>
      <!-- <div class="qrcode" ref="qrCodeUrl"></div> -->
      <div class="qrcode">
        <!-- <img :src="qrCodeUrl" alt="" @touchstart="start"> -->
        <img :src="qrCodeUrl" alt="">
      </div>
      <div class="code">经纪人代码 {{agent_code}}</div>
      <div class="app">请使用销巴生活APP扫一扫</div>
    </div>

    <div class="bottom">
      <div class="btn" @click="toSave">保存到手机相册</div>
    </div>

  </div>
</template>

<script>
import navBar from "../components/navBar";
// import QRCode from 'qrcodejs2'
// import html2canvas from 'html2canvas';
export default {
  data() {
    return {
      agent_code: this.$route.query.agent_code,
      qr_code: this.$route.query.qr_code,
      qrCodeUrl:''
    }
  },
  components: {
    navBar
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
  },
  mounted() {
    this.creatQrCode()
  },
  methods: {
    creatQrCode() {
      // var qrcode = new QRCode(this.$refs.qrCodeUrl, {
      //   // text: `${location.origin}/agent/checkAgreement`,
      //   text: this.qr_code,
      //   width: 218,
      //   height: 218,
      //   colorDark: "#000000",
      //   colorLight: "#ffffff",
      //   // correctLevel: QRCode.CorrectLevel.H,
      //   correctLevel: QRCode.CorrectLevel.L,
      // })
      // 后台直接生成图片，不用前端生成了
       this.$api.post('debt/member/agent/qr-code')
      .then(data => {
        // console.log(data)
        this.qrCodeUrl = data.img
      })
      .catch(err => {
        console.log(err)
        err.message && this.$toast(err.message)
      })
    },

    goBack() {
      this.$router.go(-1)
    },

    //点击保存
    toSave(){
      // TODO 弹出toast提示（成功保存xxx至/xxx/xxx路径），不过这里只能原生去做
      this.params(this.qrCodeUrl, this.qrCodeUrl, 'preservation')
    },

  }
};
</script>

<style lang="less">
.agent-qrcode {
  padding-top: 88px;
  height: 100%;
  box-sizing: border-box;
  background-color: #F5F6F7;
  .content {
    background-color: #fff;
    margin-top: 12px;
    padding: 34px 0;
    .title {
      width: 100%;
      text-align: center;
      height: 26px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 26px;
    }
    .qrcode {
      width: 223px;
      height: 223px;
      margin: 18px auto 8px;
      img {
        width: 100%;
      }
    }
    .code {
      width: 100%;
      text-align: center;
      height: 23px;
      font-size: 14px;
      color: #333333;
      line-height: 23px;
      margin-bottom: 2px;
    }
    .app {
      width: 100%;
      text-align: center;
      height: 26px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 26px;
    }
  }
  .bottom {
    width: 100%;
    box-sizing: border-box;
    padding: 0 33px;
    margin-top: 24px;
    .btn {
      height: 28px;
      line-height: 28px;
      background: #FC740C;
      border-radius: 25px;
      text-align: center;
      padding: 11px 0;
      font-size: 17px;
      font-weight: 500;
      color: #FFFFFF;
    }
  }
}
</style>
